// extracted by mini-css-extract-plugin
export default {"icon":"NavIconBtn_icon__iuLvA","iconBtn":"NavIconBtn_iconBtn__FDOiS"};